import React from 'react';
import {Icon, Menu} from 'tinper-bee';
import * as util from '../../../utils';
import './index.css';
import {Link} from "react-router-dom";
import Axios from 'axios';

// import { consoleSandbox } from '@sentry/utils'
const {SubMenu} = Menu;
const location = window.location;
const CAS_SERVER = 'https://user-daily.yyuap.com';

class LoginIcon extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            user: {
                id: "",
            },
        };
    }
    userSet() {}
    // async componentDidMount () {
    //   if (!localStorage.getItem('user') || localStorage.getItem('user') === 'undefined') {
    //     const searchUrl = unescape(location.search).slice(1)
    //     const ticket = this.getJsonUrl(searchUrl).get('ticket')
    //     const url = location.href.split('?')[0]
    //     const response = await axios.get(`/api/user/auth?ticket=${ticket}&service=${url}`)
    //     const { data } = response.data
    //     this.updateUserInfo(data)
    //   }
    // }

    getJsonUrl(searchUrl: string) {
        const params = searchUrl.split("&");
        const map: any = new Map();
        for (let i = 0; i < params.length; i++) {
            const ps = params[i].split("=");
            // map[ps[0]] = ps[1]
            map.set(ps[0], ps[1]);
        }
        return map;
    }

    /**
     * 登录
     */
    async signIn() {
        const url = location.href.split("?")[0];
        // location.href = CAS_SERVER + '/cas/login?sysid=yht&service=' +url
        const response = await util.get(`/user/getLogin?fromUrl=${url}`);
        const data = response.data;
        window.location.href = data.directUrl;
    }
    /**
     * 登出
     */
    async layout() {
        const url = location.href.split("?")[0];
        const response = await util.get(`/user/logout?&fromUrl=${url}`);
        const { data } = response.data;
        location.href = data || "/skill-market";
        localStorage.removeItem("user");
    }

    async test() {
        const response = await Axios.get(`https://euc.yonyoucloud.com/cas/login?sysid=yht&service=https://package.yonyoucloud.com/home`);
        console.log(response);
    }

    render() {
        let isLogin = false;
        let user;
        if (
            localStorage.getItem("user") &&
            localStorage.getItem("user") !== "undefined"
        ) {
            isLogin = true;
            const str: string = localStorage.getItem("user") || "";
            user = JSON.parse(str);
        }
        return isLogin ? (
            <Menu className="header-menu" mode="horizontal" theme="dark">
                <SubMenu
                    title={
                        <React.Fragment>
                            <img
                                style={{
                                    width: "30px",
                                    height: "30px",
                                    borderRadius: "99px",
                                    margin: "16px 8px 8px 8px",
                                }}
                                src={user.avatar}
                                alt=""
                                className="header-avatar"
                            />
                            <span
                                style={{
                                    display: "inline-block",
                                    margin: "7px 6px 8px",
                                    cursor: "pointer",
                                }}
                            >
                                {user.name}, 欢迎您~
                            </span>
                        </React.Fragment>
                    }
                >
                    <Menu.Item
                        onClick={() => (window.location.href = "/console")}
                        key="home"
                    >
                        控制台
                    </Menu.Item>
                    <Menu.Item onClick={() => this.layout()} key="logout">
                        退出
                    </Menu.Item>
                </SubMenu>
            </Menu>
        ) : (
            <a className="login-text" onClick={() => this.signIn()}>
                登录
            </a>
        );
    }
}

export default LoginIcon;
